export default 'RECORDINGS_LOADED_FROM_STORAGE';
